import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import httpService from '../api/HttpService';
import { Alert } from 'react-bootstrap';

export const PlayerRequest: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [success, setSuccess] = useState(0);

    useEffect(() => {
        const acceptRequest = async () => {
            try {
                var resp = await httpService.anonGet(`api/players/request/${id}`);
                setSuccess(1);
            }
            catch (e) {
                setSuccess(-1);
            }
        }

        acceptRequest();
    }, [id]);

    return (
        <div>
            <div className="header">
                <h1>Create player request</h1>
            </div>
            {success == 0 ?
                <div>Please wait</div>
                :
                success > 0 ?
                    <div>
                        <Alert variant="success"><strong>Player created successfully!</strong></Alert>
                        <p>You can now use your player profile with 147board scoreboard.</p>
                    </div>
                    :
                    <div>
                        <Alert variant="danger"><strong>Couldn't create player</strong></Alert>
                        <p>Please try again. If the problem persists, contact <a href="mailto:info@147board.com">info@147board.com</a></p>
                    </div>
            }
        </div>
    )
}

export default PlayerRequest;